enum Sort {
	ASC = 'ASC',
	DESC = 'DESC',
}

export default Sort;
